import { useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { AuthContext } from './authContext';

const useAuth = () => {
  const { user, setUser } = useContext(AuthContext);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedIdToken = localStorage.getItem('idToken');
      if (savedIdToken) {
        const userObject = jwtDecode(savedIdToken);
        setUser(userObject);
      }
    }
  }, []);

  return { user, setUser };
};

export default useAuth;
